import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import * as ItemTypes from "../../redux/items/types"
import { DckActionCreators, DckSelectors } from "dck-redux"
import OrganizationDetailForm from "./OrganizationDetailForm"

class OrganizationDetail extends Component {

  componentDidMount() {
    const { organization, setCurrentOrganizationId, loadOrganizations, params } = this.props
    setCurrentOrganizationId(params.id)
    if(!organization) {
      loadOrganizations()
    }
  }

  render() {
    const { organization } = this.props
    return (
      <div>
        { organization 
        ? <OrganizationDetailForm organization={ organization } />
        : <p>Loading..</p>
        }
      </div>
    )
  }
}

OrganizationDetail.propTypes = {
  organization: PropTypes.object,
  params: PropTypes.object.isRequired,
}

const mapStateToProps = (state, ownProps) => {
  const organization = DckSelectors.selectItemById(state, ItemTypes.Organization, ownProps.params.id)
  return { organization }
},

mapDispatchToProps = dispatch => ({
  setCurrentOrganizationId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Organization, id)),
  loadOrganizations: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Organization)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDetail)



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationDetail.js